/* unplugin-vue-components disabled */import { render } from "./Statement.vue?vue&type=template&id=4e5af89a"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"

import "./Statement.vue?vue&type=style&index=0&id=4e5af89a&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__